module.exports = __webpack_public_path__ + "media/images/facebook-f73c71a378f0f63f4386ccdef8241fda.png";